module.exports = __webpack_public_path__ + "static/media/heart-icon.975169d4.svg";